import CustomButton from 'components/buttons/CustomButton/CustomButton'
import CustomDialog from 'components/dialogs/CustomDialog'
import { useDeleteProcedures } from 'hooks/useProcedure';
import { snackbarService } from 'services/snackbarService';

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  userId: number;
  procedureIds: number[];
  refetch?: () => void;
  after?: () => void;
}
export default function DeleteCasesDialog({
  open,
  setOpen,
  userId,
  procedureIds,
  refetch,
  after,
}: Props) {

  const { mutate: deleteMutation, isLoading } = useDeleteProcedures(
    (res: any) => {
      const { data, status_code: statusCode } = res;
      if (statusCode == 200) {
        refetch?.();
        setOpen(false);
        after?.();
        snackbarService.showSnackbar('Patients have been deleted successfully', 'success');
      } else {
        snackbarService.showSnackbar(data, 'error');
      }
    },
    (error: any) => {
      setOpen(false);
    }
  );

  const handleConfirmDelete = () => {
    deleteMutation({
      userId,
      procedureIds,
    });
  };


  return (
    <CustomDialog
      open={open}
      title={`Delete ${procedureIds?.length == 1 ? 'Patient' : 'Patients'}`}
      message={`Note: Deleting patients is permenant and cannot be undone.`}
      alignText='left'
      buttons={[
        <CustomButton
          key='cancel'
          variant='outlined'
          text='Cancel'
          textColor='error'
          onClick={() => setOpen(false)}
          disabled={isLoading}
          height={35}
        />,
        <CustomButton
          key='delete'
          variant='filled'
          color='error'
          text='Delete anyway'
          onClick={handleConfirmDelete}
          loading={isLoading}
          height={35}
        />,
      ]}
    />
  )
}
